import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import TablaEstrategias from '../components/EstrategiaCallCenter/TablaEstrategias';
import TablaAccionesCobranzas from '../components/EstrategiaCallCenter/TablaAccionesCobranzas';
import EditarEstrategia from '../components/EstrategiaCallCenter/EditarEstrategia';
import SaveStatusMessage from '../components/EstrategiaCallCenter/SaveStatusMessage';
import ConfirmDeleteModal from '../components/EstrategiaCallCenter/ConfirmDeleteModal';
import { PlusIcon } from '@heroicons/react/24/outline';

import axios from "../configApi/axiosConfig";
import { APIURL } from '../configApi/apiConfig';

export default function EstrategiaCallCenter() {
    const fetchCbo_FlujoDeCobranzas = async () => {
        try {
            const response = await axios.get(APIURL.cbo_FlujoDeCobranzasFindAll());

            setEstrategias(response.data);
        } catch (error) {
            console.error('Error al cargar estrategias del API:', error);
            setEstrategias([]);
        }
    };

    const [estrategias, setEstrategias] = useState([]);
    const [acciones, setAcciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [estrategiaSeleccionada, setEstrategiaSeleccionada] = useState(null);
    const [formData, setFormData] = useState({
        idCbo_FlujoDeCobranzas: '',
        Periodo: '',
        idCbo_ResultadoGestion: '',
        idCbo_TipoCartera: '',
        idCbo_Riesgo: '',
        sCbo_FlujoDeCobranzas: '',
        Activo: true,
        Nota: ''
    });


    const [carteras, setCarteras] = useState([]);
    const [selectResultadoData, setSelectResultado] = useState([]);
    const [riesgoData, setRiesgoData] = useState([]);
    const [error, setError] = useState('');
    const [saveStatus, setSaveStatus] = useState(null);
    const [deleteModal, setDeleteModal] = useState({ isOpen: false, id: null, sCbo_FlujoDeCobranzas: null });
    const [deleteAccionModal, setDeleteAccionModal] = useState({ isOpen: false, item: null });
    useEffect(() => {
        fetchCbo_FlujoDeCobranzas();

        fetchSelectResultado();
        fetchRiesgo();
    }, []);

    
    // Cuando se selecciona una estrategia, cargar sus acciones
    useEffect(() => {
        if (estrategiaSeleccionada) {
            fetchAccionesCobranzas(estrategiaSeleccionada.sCbo_FlujoDeCobranzas);
        }
    }, [estrategiaSeleccionada]);

    const fetchAccionesCobranzas = async (flujoId) => {
        try {
            setLoading(true);
            // Aquí deberías llamar a tu API para obtener las acciones según el flujo seleccionado
            const response = await axios.get(APIURL.getAccionesCobranzas(flujoId));
            setAcciones(response.data);
        } catch (error) {
            console.error('Error al cargar acciones:', error);
            setAcciones([]);
        } finally {
            setLoading(false);
        }
    };



    const fetchtipocartera = async (period) => {
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(APIURL.cbo_tipoCarteraFindAll(period));

            // Manejo flexible de la respuesta
            let tipoCarteraData = [];
            if (Array.isArray(response.data)) {
                // Si la respuesta es directamente un array
                tipoCarteraData = response.data;
            } else if (Array.isArray(response.data.data)) {
                // Si está dentro de response.data.data
                tipoCarteraData = response.data.data;
            } else if (response.data.data && typeof response.data.data === 'object') {
                // Si es un objeto único
                tipoCarteraData = [response.data.data];
            }

            console.log('Carteras cargadas:', tipoCarteraData);
            setCarteras(tipoCarteraData);
        } catch (error) {
            console.error("Error fetching Tipo Cartera:", error);
            setCarteras([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchSelectResultado = async () => {
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(APIURL.Cbo_ResultadoGestionInnerJoin());

            // Manejo flexible de la respuesta
            let selectResultadoData = [];
            if (Array.isArray(response.data)) {
                selectResultadoData = response.data;
            } else if (Array.isArray(response.data.data)) {
                selectResultadoData = response.data.data;
            } else if (response.data.data && typeof response.data.data === 'object') {
                selectResultadoData = [response.data.data];
            }

            setSelectResultado(selectResultadoData);
        } catch (error) {
            console.error("Error fetching Select Resultado:", error);
            setSelectResultado([]);
        } finally {
            setLoading(false);
        }
    };


    const fetchRiesgo = async () => {
        setLoading(true);
        setError('');
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(APIURL.cbo_riesgofindall(), {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });
            let riesgoData = [];
            if (Array.isArray(response.data)) {
                riesgoData = response.data;
            } else if (Array.isArray(response.data.data)) {
                riesgoData = response.data.data;
            } else if (response.data.data && typeof response.data.data === 'object') {
                riesgoData = [response.data.data];
            }
            // Filtrar valores null o undefined
            riesgoData = riesgoData.filter(item => item !== null && item !== undefined);
            setRiesgoData(riesgoData);
        } catch (error) {
            console.error("Error fetching Riesgo:", error);
            setRiesgoData([]);
        } finally {
            setLoading(false);
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Cuando se selecciona Periodo, cargar tipos de cartera
        if (name === 'Periodo' && value) {
            setFormData({
                ...formData,
                [name]: value,
                idCbo_TipoCartera: '' // Limpiar cartera anterior
            });
            // Cargar tipos de cartera según período seleccionado
            fetchtipocartera(value);
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const handleAgregarEstrategia = () => {
        setFormData({
            idCbo_FlujoDeCobranzas: '',
            Periodo: '',
            idCbo_ResultadoGestion: '',
            idCbo_TipoCartera: '',
            idCbo_Riesgo: '',
            sCbo_FlujoDeCobranzas: '',
            Activo: true,
            Nota: ''
        });
        setEditingId(null);
        setShowForm(true);
    };

    const handleGuardarEstrategia = async () => {
        try {

            const date = new Date(formData.Periodo);
            const periodoFormateado = new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: 'long' }).format(date);
            const datosGuardar = {

                Periodo: formData.Periodo,
                idCbo_ResultadoGestion: parseInt(formData.idCbo_ResultadoGestion),
                idCbo_TipoCartera: parseInt(formData.idCbo_TipoCartera),
                idCbo_Riesgo: parseInt(formData.idCbo_Riesgo),

                Activo: formData.Activo !== undefined ? formData.Activo : true,

            };

            console.log("Datos a guardar (convertidos):", datosGuardar);
            if (formData.sCbo_FlujoDeCobranzas) {
                await patchcbo_Flujo_Cobranza(datosGuardar);
            } else {
                await putcbo_Flujo_Cobranza(datosGuardar);
            }


            // Recargar datos del API
            await fetchCbo_FlujoDeCobranzas();
            await fetchSelectResultado();
            await fetchRiesgo();

            // Mostrar mensaje de éxito
            setSaveStatus({
                type: 'success',
                message: 'Estrategia guardada correctamente'
            });

            setShowForm(false);
            setEditingId(null);
        } catch (error) {
            console.error('Error al guardar:', error);
            const mensajeError = error.response?.data?.message || error.message || 'Error al guardar la estrategia';
            setSaveStatus({
                type: 'error',
                message: mensajeError
            });
        }
    };

    const putcbo_Flujo_Cobranza = async (sflujo) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(APIURL.postcbo_flujodecobranzas(), sflujo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });

            // Verificar si la respuesta tiene statusCode diferente a 200
            if (response.data.statusCode && (response.data.statusCode !== 200 && response.data.statusCode !== 201)) {
                throw new Error(response.data.message || 'Error al guardar la estrategia');
            }

            return response.data;
        } catch (error) {
            console.error('Error al actualizar:', error);
            throw error;
        }
    };

    const patchcbo_Flujo_Cobranza = async (sflujo) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.patch(APIURL.patchcbo_flujodecobranzas(formData.sCbo_FlujoDeCobranzas), sflujo, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }
            });

            // Verificar si la respuesta tiene statusCode diferente a 200
            if (response.data.statusCode && response.data.statusCode !== 200) {
                throw new Error(response.data.message || 'Error al guardar la estrategia');
            }

            return response.data;
        } catch (error) {
            console.error('Error al actualizar:', error);
            throw error;
        }
    };

    const deletecbo_Flujo_Cobranza = async (sCbo_FlujoDeCobranzas, message) => {
        try {
            if (!sCbo_FlujoDeCobranzas) {
                throw new Error('No se encontró el identificador único de la estrategia');
            }

            const response = await axios.patch(APIURL.deletecbo_flujodecobranzas(sCbo_FlujoDeCobranzas), {
                Nota: message
            });
            return response.data;
        } catch (error) {
            console.error('Error al eliminar:', error);
            throw error;
        }
    };





    const handleEliminarEstrategia = (id) => {
        // Encontrar la estrategia a eliminar para obtener su sCbo_FlujoDeCobranzas
        const estrategiaAEliminar = estrategias.find(e => e.idCbo_FlujoDeCobranzas === id);
        setDeleteModal({
            isOpen: true,
            id,
            sCbo_FlujoDeCobranzas: estrategiaAEliminar?.sCbo_FlujoDeCobranzas
        });
    };

     const handleConfirmDelete = async (message) => {
        const id = deleteModal.id;
        const sCbo_FlujoDeCobranzas = deleteModal.sCbo_FlujoDeCobranzas;
        try {
            await deletecbo_Flujo_Cobranza(sCbo_FlujoDeCobranzas, message);

            setEstrategias(estrategias.filter(e => e.idCbo_FlujoDeCobranzas !== id));
            if (estrategiaSeleccionada?.idCbo_FlujoDeCobranzas === id) {
                setEstrategiaSeleccionada(null);
                setAcciones([]);
            }

            setDeleteModal({ isOpen: false, id: null, sCbo_FlujoDeCobranzas: null });
            setSaveStatus({
                type: 'success',
                message: 'Estrategia eliminada correctamente'
            });
        } catch (error) {
            console.error('Error al eliminar:', error);
            const mensajeError = error.response?.data?.message || error.message || 'Error al eliminar la estrategia';
            setSaveStatus({
                type: 'error',
                message: mensajeError
            });
        }
    };

    const handleEditarEstrategia = (item) => {


        // Función para convertir timestamp ISO a formato YYYY-MM-DD
        const convertToDateFormat = (dateValue) => {
            if (!dateValue) return '';

            let date;
            if (typeof dateValue === 'string') {
                date = new Date(dateValue);
            } else {
                date = dateValue;
            }

            // Ajustar por zona horaria
            const offset = date.getTimezoneOffset();
            const adjustedDate = new Date(date.getTime() - (offset * 60 * 1000));

            // Formato YYYY-MM-DD
            return adjustedDate.toISOString().split('T')[0];
        };

        // Preparar formData usando PeriodoISO si existe, sino convertir de vuelta
        const formDataToSet = {
            ...item,
            Periodo: convertToDateFormat(item.PeriodoISO || item.Periodo) // Convertir al formato correcto
        };

        console.log("formDataToSet que se asignará:", formDataToSet);
        console.log("formDataToSet.Periodo (formateado):", formDataToSet.Periodo);

        setFormData(formDataToSet);
        // Usar idCbo_FlujoDeCobranzas como ID principal para edición
        setEditingId(item.idCbo_FlujoDeCobranzas);
        setShowForm(true);

        // Cargar tipos de cartera según período
        if (item.Periodo || item.PeriodoISO) {
            fetchtipocartera(item.PeriodoISO || item.Periodo);
        }
    };

    const handleEditarAcciones = async (accionData) => {
        const datosAEnviar = {
                sCbo_FlujoDeCobranzas: accionData.sCbo_FlujoDeCobranzas,
                idCbo_Acciones: parseInt(accionData.idCbo_Acciones),
                Numero: parseInt(accionData.Numero) || 0,
                idCbo_Acciones: parseInt(accionData.idCbo_Acciones) || 0,
                Dias: parseInt(accionData.Dias) || 0,
                idMensajesMassend: parseInt(accionData.idMensajesMassend) || 0,
                Fecha: accionData.Fecha,
                Valor: accionData.Valor
        };
        try {
            await axios.patch(APIURL.updateAccionCobranza(datosAEnviar.sCbo_FlujoDeCobranzas, accionData.idCbo_AccionesCobranzas ), datosAEnviar);
            // Recargar acciones después de editar
            await fetchAccionesCobranzas(datosAEnviar.sCbo_FlujoDeCobranzas);
            setSaveStatus({
                type: 'success',
                message: 'Acción actualizada correctamente'
            });
        } catch (error) {
            console.error('Error al actualizar acción:', error);
            const mensajeError = error.response?.data?.message || error.message || 'Error al actualizar la acción';
            setSaveStatus({
                type: 'error',
                message: mensajeError
            });
        }
    };

    const handleAgregarAccion = async (accionData) => {

        try {
            await axios.post(APIURL.createAccionCobranza(), accionData);
                // Recargar acciones después de agregar
            await fetchAccionesCobranzas(accionData.sCbo_FlujoDeCobranzas);
            setSaveStatus({
                type: 'success',
                message: 'Acción agregada correctamente'
            });
        } catch (error) {
            console.error('Error al agregar acción:', error);
            const mensajeError = error.response?.data?.message || error.message || 'Error al agregar la acción';
            setSaveStatus({
                type: 'error',
                message: mensajeError
            });
        }
    };

    const handleEliminarAccion = (item) => {
        setDeleteAccionModal({
            isOpen: true,
            item
        });
    };

    const handleConfirmDeleteAccion = async () => {
        const item = deleteAccionModal.item;
        try {
            await axios.delete(APIURL.deletecbo_Acciones(item.sCbo_FlujoDeCobranzas, item.idCbo_AccionesCobranzas));
            await fetchAccionesCobranzas(item.sCbo_FlujoDeCobranzas);
            
            setDeleteAccionModal({ isOpen: false, item: null });
            setSaveStatus({
                type: 'success',
                message: 'Acción eliminada correctamente'
            });
        } catch (error) {
            console.error('Error al eliminar acción:', error);
            const mensajeError = error.response?.data?.message || error.message || 'Error al eliminar la acción';
            setSaveStatus({
                type: 'error',
                message: mensajeError
            });
            setDeleteAccionModal({ isOpen: false, item: null });
        }
    };

    return (
        <Layout>
            {saveStatus && (
                <SaveStatusMessage
                    type={saveStatus.type}
                    message={saveStatus.message}
                    onClose={() => setSaveStatus(null)}
                />
            )}

            <ConfirmDeleteModal
                isOpen={deleteModal.isOpen}
                title="¿Eliminar estrategia?"
                description="Está a punto de eliminar una estrategia de cobranza. Esta acción no se puede deshacer."
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeleteModal({ isOpen: false, id: null, sCbo_FlujoDeCobranzas: null })}
            />
            <ConfirmDeleteModal
                isOpen={deleteAccionModal.isOpen}
                title="¿Eliminar acción de cobranza?"
                description="Está a punto de eliminar una acción de cobranza. Esta acción no se puede deshacer."
                onConfirm={handleConfirmDeleteAccion}
                onCancel={() => setDeleteAccionModal({ isOpen: false, item: null })}
            />
            <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-6">
                <div className="w-full px-6">
                    {/* Header Principal */}
                    <div className="mb-6">
                        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                            <div>
                                <div className="flex items-center gap-3 mb-2">
                                    <div className="p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                        </svg>
                                    </div>
                                    <h1 className="text-3xl font-black text-white">Call Center Retail</h1>
                                </div>
                                <p className="text-slate-400 text-sm">Estrategia de Cobranza y Gestión de Llamadas</p>
                            </div>
                            <button
                                onClick={handleAgregarEstrategia}
                                className="px-6 py-3 bg-gradient-to-r from-emerald-500 via-emerald-600 to-teal-600 hover:from-emerald-600 hover:via-emerald-700 hover:to-teal-700 text-white font-bold rounded-xl shadow-xl hover:shadow-2xl transition-all flex items-center gap-2 whitespace-nowrap transform hover:scale-105"
                            >
                                <PlusIcon className="w-5 h-5" />
                                Nueva Estrategia
                            </button>
                        </div>
                    </div>

                    {/* Tarjetas de Estadísticas */}
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
                        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl p-6 shadow-lg">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-blue-100 text-sm font-semibold uppercase tracking-wide">Total Estrategias</p>
                                    <p className="text-4xl font-black text-white mt-2">{estrategias.length}</p>
                                </div>
                                <div className="p-3 bg-white/20 rounded-lg">
                                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-purple-600 to-purple-700 rounded-xl p-6 shadow-lg">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-purple-100 text-sm font-semibold uppercase tracking-wide">Acciones Totales</p>
                                    <p className="text-4xl font-black text-white mt-2">{acciones.length}</p>
                                </div>
                                <div className="p-3 bg-white/20 rounded-lg">
                                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-orange-600 to-orange-700 rounded-xl p-6 shadow-lg">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-orange-100 text-sm font-semibold uppercase tracking-wide">Riesgo Promedio</p>
                                    <p className="text-4xl font-black text-white mt-2">
                                        {estrategias.length > 0
                                            ? ((estrategias.filter(e => e.idCbo_Riesgo === 'Alto').length / estrategias.length) * 100).toFixed(0)
                                            : 0}%
                                    </p>
                                </div>
                                <div className="p-3 bg-white/20 rounded-lg">
                                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4v2m0 4v2M6.228 6.228l1.414 1.414m2.828 2.829l1.414 1.414m2.828 2.828l1.414 1.414m2.829 2.829l1.414 1.414M9.228 4.228l-1.414-1.414m0 5.656l-1.414 1.414m5.656 5.656l1.414 1.414m0-5.656l1.414-1.414" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-xl p-6 shadow-lg">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-emerald-100 text-sm font-semibold uppercase tracking-wide">Seleccionada</p>
                                    <p className="text-2xl font-black text-white mt-2">{estrategiaSeleccionada?.Periodo || 'Ninguna'}</p>
                                </div>
                                <div className="p-3 bg-white/20 rounded-lg">
                                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Form Modal para Estrategias */}
                    <EditarEstrategia
                        showForm={showForm}
                        onClose={() => setShowForm(false)}
                        onSave={handleGuardarEstrategia}
                        formData={formData}
                        onInputChange={handleInputChange}
                        editingId={editingId}
                        selectResultadoData={selectResultadoData}
                        carteras={carteras}
                        riesgoData={riesgoData}
                    />

                    {/* Grid Principal - 2 columnas */}
                    <div className="grid grid-cols-1 xl:grid-cols-4 gap-6 mt-6 h-[calc(100vh-420px)]">
                        {/* Columna Izquierda - Estrategias (1 columna) */}
                        <div className="xl:col-span-1">
                            <TablaEstrategias
                                estrategias={estrategias}
                                loading={loading}
                                onAgregar={handleAgregarEstrategia}
                                onEditar={handleEditarEstrategia}
                                onEliminar={handleEliminarEstrategia}
                                onSeleccionar={setEstrategiaSeleccionada}
                                estrategiaSeleccionada={estrategiaSeleccionada}
                            />
                        </div>

                        {/* Columna Derecha - Acciones (2 columnas) */}
                        <div className="xl:col-span-3">
                            <TablaAccionesCobranzas
                                acciones={acciones}
                                loading={loading}
                                estrategiaSeleccionada={estrategiaSeleccionada}
                                onAgregar={handleAgregarAccion}
                                onEditar= {handleEditarAcciones}
                                onEliminar={handleEliminarAccion}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
